module.exports = __webpack_public_path__ + "static/media/lighthouse710_logo.15d61c59.jpg";